import React from 'react'

import style from './Loading.css'

export default class Loading extends React.Component {
  
  render() {
    const { show, message = '' } = this.props
    
    return ( show && (
      <div className={style.loading}>
        <i className="fa fa-spin fa-refresh fa-lg" />
        { message ? <div>{message}</div> : null }
      </div>
    ) )
  }
}
